import React, { useRef, useState } from 'react'
import './styles.scss'

interface FileDropZoneProps {
  onFilesSelected: (files: File[]) => void
}

const FileDropZone = ({ onFilesSelected }: FileDropZoneProps): JSX.Element => {
  const [isDragging, setIsDragging] = useState(false)
  const inputRef = useRef<HTMLInputElement>(null)

  // Handle dropped files
  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault()
    setIsDragging(false)
    const files = event.dataTransfer.files
    if (files && files.length > 0) {
      onFilesSelected(Array.from(files))
    }
  }

  // Handle click to trigger input
  const handleClick = () => {
    inputRef?.current?.click()
  }

  // Handle standard file input change
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files
    if (files && files.length > 0) {
      onFilesSelected(Array.from(files))
    }
  }

  return (
    <div
      tabIndex={0}
      role='button'
      aria-label='File upload drop zone'
      className={`dropzone${isDragging ? ' dragging' : ''}`}
      onClick={handleClick}
      onDragOver={(e) => {
        e.preventDefault()
        setIsDragging(true)
      }}
      onDragEnter={(e) => {
        e.preventDefault()
        setIsDragging(true)
      }}
      onDragLeave={() => setIsDragging(false)}
      onDrop={handleDrop}
    >
      <input
        ref={inputRef}
        type='file'
        multiple
        style={{ display: 'none' }}
        onChange={handleInputChange}
        tabIndex={-1}
      />
      {isDragging ? 'Drop files here...' : 'Drop files here...'}
    </div>
  )
}

export default FileDropZone
